import { collection, doc, getDoc, updateDoc, getDocs, setDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { classes, Model } from '../models/Model';
import { Plan } from '../models/Plan';

export default function modelService() {
  async function createModel(className: classes, userId: string): Promise<Model> {
    try {
      // Add a new document with a generated id
      const modelRef = doc(collection(db, 'model'));
      const newModel: Model = {
        id: modelRef.id,
        class: className,
        userId: userId,
        createdAt: new Date(),
        trained: false,
      };
      // later...
      await setDoc(modelRef, newModel);
      return newModel;
    } catch (e) {
      console.error('Error adding document: ', e);
      return null;
    }
  }

  async function updateModel(modelId: string, Model: Partial<Model>): Promise<boolean> {
    try {
      const modelRef = doc(db, 'model', modelId);
      await updateDoc(modelRef, { ...Model });
      console.log('model updated ');
      return true;
    } catch (e) {
      console.error('Error updating document: ', e);
      return false;
    }
  }

  // TODO: use onSnapshot(collection(db, "model", id) to update model in context
  async function getModel(id: string): Promise<Model> {
    const modelRef = doc(db, 'model', id);
    const modelSnap = await getDoc(modelRef);
    if (modelSnap.exists()) {
      console.log('Document data:', modelSnap.data());
      return modelSnap.data() as Model;
    } else {
      // doc.data() will be undefined in this case
      console.log('No such document!');
      return null;
    }
  }

  async function getAllModels(): Promise<Model[]> {
    const modelRef = collection(db, 'model');
    const modelSnap = await getDocs(modelRef);
    let models: Model[] = [];
    if (modelSnap) {
      modelSnap.forEach((element) => {
        models.push(element.data() as Model);
      });
      return models;
    } else {
      // doc.data() will be undefined in this case
      console.log('No such collection!');
      return null;
    }
  }

  return {
    createModel,
    updateModel,
    getModel,
    getAllModels,
  };
}
